export default __webpack_public_path__ + "static/media/menu-achievements.64c94d72.svg";